import React, { useRef, useState } from "react";
import emailjs from "@emailjs/browser";

const Contact = () => {
  const form = useRef();
  const [status, setStatus] = useState("");

  const sendEmail = (e) => {
    e.preventDefault();
    setStatus("Sending...");

    emailjs
      .sendForm(
        "service_iwjgzma",        // Replace with your EmailJS Service ID
        "template_f3dke2e",       // Replace with your EmailJS Template ID
        form.current,
        "fKSxBmlR289e4FGFZ"         // Replace with your EmailJS Public Key
      )
      .then(
        (result) => {
          console.log(result.text);
          setStatus("Message sent successfully!");
          form.current.reset(); // Reset the form
        },
        (error) => {
          console.error(error.text);
          setStatus("Failed to send message. Please try again.");
        }
      );
  };

  return (
    <section className="py-5 bg-light" id="Contact">
      <div className="container">
        <h2 className="text-center mb-4 fw-bold text-uppercase" style={{ color: "#38C6C3" }}>
          Contact Us
        </h2>
        <div className="row">
          {/* Left side: Form */}
          <div className="col-md-6 mb-4">
            <h4 className="mb-4" style={{ color: "#0f174f" }}>
              Please complete this form below for one of our Sales Representatives to contact you:
            </h4>
            <form ref={form} onSubmit={sendEmail}>
              <div className="mb-3">
                <label className="form-label">Business Name</label>
                <input type="text" name="business_name" className="form-control" required />
              </div>

              <div className="mb-3">
                <label className="form-label">Contact Person</label>
                <input type="text" name="contact_person" className="form-control" required />
              </div>

              <div className="mb-3">
                <label className="form-label">Contact Number</label>
                <input type="text" name="contact_number" className="form-control" required />
              </div>

              <div className="mb-3">
                <label className="form-label">Contact Email</label>
                <input type="email" name="contact_email" className="form-control" required />
              </div>

              <div className="mb-3">
                <label className="form-label">Business Address</label>
                <input type="text" name="address" className="form-control" required />
              </div>

              <div className="mb-4">
                <label className="form-label">Message</label>
                <textarea name="message" className="form-control" rows="4"></textarea>
              </div>

              <button
                type="submit"
                className="btn"
                style={{
                  backgroundColor: "#0f174f",
                  color: "white",
                  borderRadius: "50px",
                  fontWeight: "bold",
                  width: "150px",
                }}
              >
                SEND
              </button>

              {status && (
                <div className="mt-3 alert alert-info" role="alert">
                  {status}
                </div>
              )}
            </form>
          </div>

          {/* Right side: Contact Info */}
          <div className="col-md-6">
            <p>
              Let us tailor a service package that meets your needs. Tell us a little about your business, and we will get back to you with some ideas as soon as possible.
            </p>

            <h5 className="mt-4">FTTBSA</h5>

            <h6 className="mt-4">Hours</h6>
            <p className="mb-1">Monday - Friday: 7am - 9pm</p>
            <p>Saturday - Sunday: 7am - 5pm</p>

            <h6 className="mt-4">Physical Address</h6>
            <p className="mb-1">116 Oxford Street, Frendale</p>
            <p className="mb-1">Randburg, Johannesburg</p>
            <p>2194</p>

            <div className="mt-3">
              <iframe
                title="FTTBSA Location"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3582.4255138995373!2d28.04536877536731!3d-26.10841967710474!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1e950cce174ebf5d%3A0x6896fbe2cb55a4b6!2s116%20Oxford%20Rd%2C%20Ferndale%2C%20Randburg%2C%202194%2C%20South%20Africa!5e0!3m2!1sen!2sza!4v1718560000000!5m2!1sen!2sza"
                width="100%"
                height="250"
                style={{ border: 0, borderRadius: "8px" }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
